import api from './api';

// Serviço para operações de matrículas

export const matriculaService = {
  
  // Listar matrículas com filtros
  async listarMatriculas({ page = 1, limit = 10, ...filtros } = {}) {
    try {
      const params = { page, limit, ...filtros };
      const response = await api.get('/matriculas', { params });
      
      // A API retorna: { success: true, data: [...], pagination: {...} }
      return {
        success: response.data.success,
        data: response.data.data || [],
        pagination: response.data.pagination || {}
      };
    } catch (error) {
      console.error('Erro ao listar matrículas:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: []
      };
    }
  },

  // Buscar matrícula por ID
  async buscarMatricula(id) {
    try {
      const response = await api.get(`/matriculas/${id}`);
      return {
        success: true,
        data: response.data?.data || null
      };
    } catch (error) {
      console.error('Erro ao buscar matrícula:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: null
      };
    }
  },

  // Criar nova matrícula
  async criarMatricula(dados) {
    try {
      const response = await api.post('/matriculas', dados);
      return {
        success: true,
        data: response.data?.data || null,
        message: response.data?.message || 'Matrícula criada com sucesso'
      };
    } catch (error) {
      console.error('Erro ao criar matrícula:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        details: error.response?.data?.error || null
      };
    }
  },

  // Criar matrículas em massa para múltiplas pessoas
  async criarMatriculaMassa(dados) {
    try {
      const response = await api.post('/matriculas/massa', dados);
      return {
        success: true,
        data: response.data?.data || null,
        message: response.data?.message || 'Matrículas processadas'
      };
    } catch (error) {
      console.error('Erro ao criar matrículas em massa:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        details: error.response?.data?.error || null
      };
    }
  },

  // Editar matrícula
  async editarMatricula(id, dados) {
    try {
      const response = await api.put(`/matriculas/${id}`, dados);
      return {
        success: true,
        message: response.data?.message || 'Matrícula atualizada com sucesso'
      };
    } catch (error) {
      console.error('Erro ao editar matrícula:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Trancar matrícula
  async trancarMatricula(id, dados) {
    try {
      const response = await api.post(`/matriculas/${id}/trancar`, dados);
      return {
        success: true,
        message: response.data?.message || 'Matrícula trancada com sucesso'
      };
    } catch (error) {
      console.error('Erro ao trancar matrícula:', error);
      const errorResponse = error.response?.data || {};
      return {
        success: false,
        error: errorResponse.message || error.message,
        details: errorResponse.details || null,
        validationErrors: errorResponse.details || null
      };
    }
  },

  // Reativar matrícula
  async reativarMatricula(id, dados) {
    try {
      const response = await api.post(`/matriculas/${id}/reativar`, dados);
      return {
        success: true,
        message: response.data?.message || 'Matrícula reativada com sucesso'
      };
    } catch (error) {
      console.error('Erro ao reativar matrícula:', error);
      const errorResponse = error.response?.data || {};
      return {
        success: false,
        error: errorResponse.message || error.message,
        details: errorResponse.details || null,
        validationErrors: errorResponse.details || null
      };
    }
  },

  // Concluir matrícula
  async concluirMatricula(id, dados) {
    try {
      const response = await api.post(`/matriculas/${id}/concluir`, dados);
      return {
        success: true,
        message: response.data?.message || 'Matrícula concluída com sucesso'
      };
    } catch (error) {
      console.error('Erro ao concluir matrícula:', error);
      const errorResponse = error.response?.data || {};
      return {
        success: false,
        error: errorResponse.message || error.message,
        details: errorResponse.details || null,
        validationErrors: errorResponse.details || null
      };
    }
  },

  // Cancelar matrícula
  async cancelarMatricula(id, motivo) {
    try {
      const response = await api.delete(`/matriculas/${id}`, {
        data: { motivoCancelamento: motivo }
      });
      return {
        success: true,
        message: response.data?.message || 'Matrícula cancelada com sucesso'
      };
    } catch (error) {
      console.error('Erro ao cancelar matrícula:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Buscar matrículas de um aluno
  async buscarMatriculasAluno(idAluno, filtros = {}) {
    try {
      const response = await api.get(`/matriculas/aluno/${idAluno}`, { 
        params: filtros 
      });
      return {
        success: true,
        data: response.data?.data || []
      };
    } catch (error) {
      console.error('Erro ao buscar matrículas do aluno:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: []
      };
    }
  },

  // Buscar matrículas de um curso
  async buscarMatriculasCurso(idCurso, filtros = {}) {
    try {
      const response = await api.get(`/matriculas/curso/${idCurso}`, { 
        params: filtros 
      });
      return {
        success: true,
        data: response.data?.data || []
      };
    } catch (error) {
      console.error('Erro ao buscar matrículas do curso:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: []
      };
    }
  },

  // Verificar se aluno pode ser matriculado no curso
  async verificarDisponibilidade(idAluno, idCurso) {
    try {
      const matriculasAluno = await this.buscarMatriculasAluno(idAluno, {
        status: 'Ativa'
      });

      if (!matriculasAluno.success) {
        return matriculasAluno;
      }

      const jaMatriculado = matriculasAluno.data.some(
        matricula => matricula.idCurso === parseInt(idCurso) && 
                    ['Ativa', 'Trancada'].includes(matricula.status)
      );

      return {
        success: true,
        disponivel: !jaMatriculado,
        motivo: jaMatriculado ? 'Aluno já possui matrícula ativa ou trancada neste curso' : null
      };
    } catch (error) {
      console.error('Erro ao verificar disponibilidade:', error);
      return {
        success: false,
        error: error.message,
        disponivel: false
      };
    }
  },

  // Obter estatísticas rápidas
  async obterEstatisticas(filtros = {}) {
    try {
      const response = await api.get('/matriculas', { 
        params: { ...filtros, limit: 1000 } // Buscar todas para estatísticas
      });
      
      if (!response.data?.data) {
        return { success: false, error: 'Dados não encontrados' };
      }

      const matriculas = response.data.data;
      
      const estatisticas = {
        total: matriculas.length,
        ativas: matriculas.filter(m => m.status === 'Ativa').length,
        trancadas: matriculas.filter(m => m.status === 'Trancada').length,
        concluidas: matriculas.filter(m => m.status === 'Concluida').length,
        canceladas: matriculas.filter(m => m.status === 'Cancelada').length,
        porCurso: {},
        porStatus: {}
      };

      // Agrupar por curso
      matriculas.forEach(matricula => {
        const curso = matricula.nomeCurso || 'Sem curso';
        if (!estatisticas.porCurso[curso]) {
          estatisticas.porCurso[curso] = 0;
        }
        estatisticas.porCurso[curso]++;
      });

      // Agrupar por status
      matriculas.forEach(matricula => {
        const status = matricula.status || 'Sem status';
        if (!estatisticas.porStatus[status]) {
          estatisticas.porStatus[status] = 0;
        }
        estatisticas.porStatus[status]++;
      });

      return {
        success: true,
        data: estatisticas
      };
    } catch (error) {
      console.error('Erro ao obter estatísticas:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Imprimir histórico acadêmico
  async imprimirHistorico(idMatricula) {
    try {
      const response = await api.get(`/historico-academico/matricula/${idMatricula}/pdf`, {
        responseType: 'blob', // Importante para download de PDF
        timeout: 120000 // 2 minutos para geração de PDF (Puppeteer pode demorar)
      });

      // Criar URL temporária para o blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `historico_matricula_${idMatricula}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Histórico impresso com sucesso'
      };
    } catch (error) {
      console.error('Erro ao imprimir histórico:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao imprimir histórico'
      };
    }
  },

  // Imprimir múltiplos históricos em um único PDF
  async imprimirHistoricosMassaPDF(ids) {
    try {
      const response = await api.post('/historico-academico/massa/pdf', { ids }, {
        responseType: 'blob',
        timeout: 300000 // 5 minutos para múltiplos PDFs
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `historicos_em_massa_${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true, message: 'Históricos impressos com sucesso' };
    } catch (error) {
      console.error('Erro ao imprimir históricos em massa:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao imprimir históricos em massa'
      };
    }
  },

  // Buscar dados do histórico acadêmico
  async buscarDadosHistorico(idMatricula) {
    try {
      const response = await api.get(`/historico-academico/matricula/${idMatricula}/imprimir`);
      return {
        success: response.data.success || true,
        data: response.data.data || null
      };
    } catch (error) {
      console.error('Erro ao buscar dados do histórico:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: null
      };
    }
  },

  // Obter estatísticas do servidor
  async obterEstatisticas() {
    try {
      const response = await api.get('/matriculas/stats');
      
      return {
        success: response.data.success || true,
        data: {
          estatisticas: response.data.data?.estatisticas || {}
        }
      };
    } catch (error) {
      console.error('Erro ao obter estatísticas:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: {
          estatisticas: {}
        }
      };
    }
  },

  // Ajustar número de matrícula
  async ajustarNumeroMatricula(idMatricula, novoNumero) {
    try {
      const response = await api.patch(`/matriculas/${idMatricula}/numero`, {
        numeroMatricula: novoNumero
      });
      
      return {
        success: true,
        message: response.data.message || 'Número de matrícula atualizado com sucesso',
        data: response.data.data
      };
    } catch (error) {
      console.error('Erro ao ajustar número de matrícula:', error);
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Erro ao ajustar número de matrícula'
      };
    }
  },

  // Exportar matrículas concluídas selecionadas para Excel (template de certificado)
  async exportarExcelConcluidos(ids) {
    try {
      const response = await api.post('/matriculas/exportar-excel', { ids });
      return {
        success: true,
        data: response.data?.data || []
      };
    } catch (error) {
      console.error('Erro ao exportar matrículas para Excel:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: []
      };
    }
  }
};

export default matriculaService;